import Alarm from './Alarm'

export interface Resettable {
  reset(): void
}

export default Alarm
